<script>
    export let chapterData
    export let bookName
    export let chapterNumber

    $: description = chapterData?.length ? chapterData[0]?.chapterDescription : ''
    $: bookDescription = chapterData.length ? chapterData[0]?.bookDescription : ''
    $: verses = chapterData?.slice(1) || []
</script>

<style>
    .columns {
        columns: 1
    }
    @media (min-width: 768px) {
        .columns {
            columns: 2
        }
    }
</style>

<div>
    <h1 class="text-4xl text-center px-6 md:px-14">{bookName}</h1>
    <h2 class="text-3xl text-center px-6 md:px-14">Chapter {chapterNumber}</h2>
    {#if bookDescription}
        <p class="text-sm text-center italic my-3 px-6 md:px-14">{bookDescription}</p>
    {/if}
    <p class="text-sm text-center italic my-3 px-6 md:px-14">{description}</p>
    <div class="px-6 md:px-14 columns">
        {#each verses as verse}
            <p class="my-2.5 px-1 w-full"><sup>{verse.verseNum}</sup> {verse.verseText}</p>
        {/each}
    </div>
</div>
